// @ts-nocheck
import 'reflect-metadata';

import React, {Component} from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { ChartProvider } from './charts/ChartProvider';
import { ScatterChartProvider } from './charts/scatter/ScatterChartProvider';
import { BarChartProvider } from './charts/bar/BarChartProvider';
import { Definition } from '../data/Definition';
import DwQueryClient from '../data/DwQueryClient';
import { IDwCrossFilter, IDwFilter, IDwFilterWarapper, DwQuery } from '../data/Query';
//import Plotly from 'plotly.js-dist';
import createPlotlyComponent from 'react-plotly.js/factory';
import DefaultChartLayout from './charts/DefPlotLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faFilter } from '@fortawesome/free-solid-svg-icons';
import { withApollo } from 'react-apollo';
import { getDataDefinitions } from '../data/utils';

import { SocketContext } from '../context/socket';
import { StatsTimeSeriesChartProvider } from './charts/time_series/StatsTimeSeriesChartProvider';

const Plot = createPlotlyComponent(window.Plotly);

interface IDwChartConfig {
    chartType: string;
    definitionId: number;
    chartConfig: any;
}

class DashboardChart2Widget extends Component<any, any> {
    private socket: SocketIOClient.Socket;
    private chartTypes: ChartProvider[];
    private selectedPoints: [] | null = null;
    private crossFilters: IDwCrossFilter[] = [];
    private chartConfig: IDwChartConfig | null = null;

    static contextType = SocketContext;
    context!: React.ContextType<typeof SocketContext>;

    constructor(props: any) {
        super(props);

        this.state = {
            definitionWrappers: [],
            selectedDefinitionWrapper: null,
            selectedChartProvider: null,
            chart: {
                data: [],
                layout: DefaultChartLayout
            },
            showModal: false,
            revisionNo: 1,
            selectionFilter: null,
            showHoverButtons: false,
        }

        this.socket = undefined!;
        this.chartTypes = [
            new BarChartProvider(),
            new ScatterChartProvider(),
            new StatsTimeSeriesChartProvider()
        ];

        this.configUpdated = this.configUpdated.bind(this);
    }

    async componentDidMount() {
        console.log('chart > DW Chart widget loaded');

        this.socket = this.context!;

        const definitionWrappers = await getDataDefinitions(this.props.client);

        this.setState({
            definitionWrappers
        });

        await this.initialLoad();

        this.socket.on('chart', (msg: any) => {
            console.log('chart > got chart message', msg, this.props.widgetInstance.id);
            if (msg.command === 'chartConfigUpdated' && msg.widgetInstanceId) {
                if (msg.widgetInstanceId === this.props.widgetInstance.id) {
                    if(msg.chartConfig) {
                        this.chartConfig = msg.chartConfig;
                        this.loadChart(this.chartConfig!);
                    }
                }
            } else if(msg.command === 'filtersChanged') {
                console.log('chart > filters changed', this.props.widgetInstance.id, msg.filters);
                this.updateCrossFilters(msg.filters);
            } else if(msg.command === 'filterSelected') {
                if (msg.widgetInstanceId !== this.props.widgetInstance.id) {
                    return;
                }

                this.setState({
                    selectionFilter: msg.filter
                });
            }
        });
    }

    async initialLoad() {
        console.log('chart > initial load', this.props.config ? JSON.parse(this.props.config) : 'null');

        if(this.props.config !== undefined) {
            this.chartConfig = JSON.parse(this.props.config);

            if(!this.chartConfig || !this.chartConfig.definitionId) {
                return;
            }

            // get the provider for this type.
            const chartProvider = this.chartTypes.find((p: ChartProvider) => p.name === this.chartConfig!.chartType);
            if(!chartProvider) {
                return;
            }

            // get the data definition.
            const defWarapper = this.state.definitionWrappers.find((d:any) => d.id === this.chartConfig!.definitionId);
            if(!defWarapper) {
                console.error('Unable to load data definition: ', this.chartConfig!.definitionId);
                return;
            }

            await this.setState((state: any) => {
                return {
                    selectedChartProvider: chartProvider,
                    selectedDefinitionWrapper: defWarapper
                 };
            });

            const configManager = chartProvider.configManager(defWarapper.definition);
            if(!configManager.isCurrentVersion(this.chartConfig.chartConfig)) {
                console.log('chart2Widget > before converting chart config', this.chartConfig.chartConfig);
                this.chartConfig.chartConfig = configManager.convert(this.chartConfig.chartConfig);
                console.log('chart2Widget > after converting chart config', this.chartConfig.chartConfig);
            }

            if(!configManager.validate(this.chartConfig.chartConfig)) {
                console.log('chart2Widget > configuration not valid', this.chartConfig.chartConfig);
                return;
            }

            await this.loadChart(this.chartConfig);

            // broadcast the configured filters defined by this config.
            const query: null | DwQuery = this.queryFromConfig(this.chartConfig);

            if(query) {
                if(query.filters.length > 0) {
                    this.publishFilters(
                        query.filters?.map((f:IDwFilter) => {
                            return {
                                definitionId: this.chartConfig != null ? this.chartConfig.definitionId : 0,
                                filter: f,
                                bySelection: false
                            };
                        })
                    );
                }
            }
        }
    }

    async updateCrossFilters(filters: IDwCrossFilter[]) {
        // save the x filters and force a reload of the chart.
        this.crossFilters = filters;

        console.log('chart > updateCrossFilters', this.props.widgetInstance.id, this.chartConfig, this.state.selectedChartProvider);

        if(this.chartConfig !== null && this.state.selectedChartProvider !== null) {
            await this.loadChart(this.chartConfig);
        }
    }

    async loadChart(chartConfig: IDwChartConfig | null) {
        console.log('chart > loadChart', this.props.widgetInstance.id);

        const { selectedChartProvider, selectedDefinitionWrapper } = this.state;

        if(chartConfig === null || selectedChartProvider == null || selectedDefinitionWrapper == null) {
            return;
        }
        console.log("selectedChartProvider", selectedChartProvider);
        console.log("selectedDefinitionWrapper", selectedDefinitionWrapper);
        // given the chart config for the specific chart provider, convert
        // the configuration to a query.
        //
        console.log('chart > loadChart chartConfig', chartConfig.chartConfig);
        let query = selectedChartProvider.getQuery(selectedDefinitionWrapper.definition, chartConfig.chartConfig);
        console.log('chart > loadChart query', query);

        if(!query) {
            return;
        }

        this.updateQueryWithCrossFilters(query, selectedDefinitionWrapper.definition, chartConfig);

        try {
            console.log("query", query);
            const data = await this.queryData(query);
            console.log("data", data);
            const plotConfig = selectedChartProvider.getPlotly(selectedDefinitionWrapper.definition, chartConfig.chartConfig, data);

            // update plot state with plot config, this will force the render of the plot.
            //
            plotConfig.layout.datarevision = this.state.revisionNo + 1;

            if(plotConfig.data.length > 0) {
                plotConfig.data[0].selectedpoints = this.selectedPoints !== null ? this.selectedPoints?.map((p:any) => p.index) : null;
            }

            this.setState((state: any) => {
                return {
                    chart: plotConfig,
                    revisionNo: state.revisionNo + 1
                 };
            });

            console.log('chart > load chart end', this.props.widgetInstance.id);

        } catch(err) {
            console.error(err);
        }
    }

    updateQueryWithCrossFilters(query: DwQuery, definition: Definition, chartConfig: IDwChartConfig) {
        const filters = this.crossFilters.filter((filter:IDwCrossFilter) => {
            const sameWidget = filter.widgetInstanceId === this.props.widgetInstance.id;
            const sameDefinition = filter.definitionId === query.definitionId || filter.definitionId === -1;

            // only apply the filters that are selection for the same widget, or all
            // if not the same widget. we are already applying the non-selection filters.
            // that is, the filters configured in THIS widget's filter list will not be applied again
            //
            return (sameWidget && filter.bySelection) || (!sameWidget && sameDefinition);
        });

        // if the list of filters includes a geospatial filter, we check the the current
        // chart config if a spatial entity has been configured. If so, update the filter
        // to include the configured entity.
        //
        const geoIndex = filters.findIndex((f:IDwCrossFilter) => {
            return f.filter.type === 'geojson';
        });

        // TODO. move this out of the widget to the provider. the widget does not
        // know the structure of the config and this assumes that there is a spatial
        // property.
        if(geoIndex !== -1) {
            if(chartConfig.chartConfig.spatial && chartConfig.chartConfig.spatial.item) {
                // TODO: handle the path (id) to the spatial entity more generically.
                filters[geoIndex].filter.id = `${definition.name}:${chartConfig.chartConfig.spatial.item.name}`;
                filters[geoIndex].filter.feature = chartConfig.chartConfig.spatial.item.feature;
            } else {
                // remove it since we dont know what entity to apply.
                filters.splice(geoIndex, 1);
            }
        }

        // update the query object to include the selected filters.
        //
        const queryFilters: IDwFilter[] = filters?.map((item:IDwCrossFilter) => item.filter);
        console.log('chart > cross-filters applied to query', filters);

        query.filters.push(...queryFilters);
    }

    async queryData(query: DwQuery) {
        const api = new DwQueryClient(process.env.REACT_APP_CHATBOT_URL!);

        try {
            return await api.doQuery(query, "chart");
        } catch(e) {
            console.error(e);
        }

        return null;
    }

    chartPropertiesForm(): React.ReactNode {
        const { selectedChartProvider, definitionWrappers, selectedDefinitionWrapper } = this.state;

        if (definitionWrappers.length === 0) {
            return (<div>No data definitions configured in the data warehouse.</div>);
        }

        // if a provider is selected, use its renderer.
        let providerForm;

        if(selectedChartProvider != null && selectedDefinitionWrapper != null) {
            providerForm = selectedChartProvider.getConfigForm(selectedDefinitionWrapper.definition, this.chartConfig ? this.chartConfig.chartConfig : null, this.configUpdated);
        } else {
            providerForm = '';
        }

        return (
            <Form>
                <Form.Group controlId="ChartDataSourceControlSelect">
                    <Form.Label>Data Source</Form.Label>
                    <Form.Control as="select" name="chart-type"
                        onChange={this.onChangeDefinition.bind(this)}
                        defaultValue={selectedDefinitionWrapper ? selectedDefinitionWrapper.id : undefined}>
                        <option value="0">Select a data source definition</option>
                        {this.state.definitionWrappers?.map((d:any) => <option key={d.id} value={d.id}>{d.name}</option>)}
                    </Form.Control>
              </Form.Group>

              { selectedDefinitionWrapper ?
              <Form.Group controlId="ChartTypeControlSelect">
                <Form.Label>Chart Type</Form.Label>
                <Form.Control as="select" name="chart-type"
                    onChange={this.onChangeChartType.bind(this)}
                    defaultValue={selectedChartProvider ? selectedChartProvider.name : undefined}>
                    <option value="0">Select a chart type</option>
                    {this.chartTypes?.map((type) => <option key={type.name} value={type.name}>{type.name}</option>)}
                </Form.Control>
              </Form.Group>
              : ''
              }

              { providerForm }
            </Form>
        );
    }

    onChangeChartType(e: any) {
        let provider = this.chartTypes.find((item: ChartProvider) => item.name === e.target.value);

        this.setState({
            selectedChartProvider: provider
        });
    }

    onChangeDefinition(e: any) {
        // eslint-disable-next-line
        let wrapper = this.state.definitionWrappers.find((d: any) => d.id == e.target.value);

        this.setState( {
            selectedDefinitionWrapper: wrapper
        });
    }

    configUpdated(chartConfig: any) {
        // send a config updated message through the chatbot and tell the
        // dashboard that a config has been updated.
        console.log('chart > configUpdated', chartConfig);

        const newConfig: IDwChartConfig =  {
            chartType: this.state.selectedChartProvider.name,
            definitionId: this.state.selectedDefinitionWrapper.id,
            chartConfig: chartConfig
        };

        // send message to everyone, including self to update based on the
        // new chart configuration.
        this.socket.emit('chart', {
            command: 'chartConfigUpdated',
            chartConfig: newConfig,
            widgetInstanceId: this.props.widgetInstance.id,
            widgetInstanceTitle: this.props.widgetInstance.title
        });

        // tell the dashboard the config data changed for this widget.
        // this config change will get persisted on dashboard saves.
       this.props.configUpdate(
            this.props.widgetInstance.id,
            JSON.stringify(newConfig)
        );

        // publish the current state of the filters.
        const query = this.queryFromConfig(newConfig);

        if(query) {
            this.publishFilters(
                query.filters?.map((f: IDwFilter) => {
                    return {
                        definitionId: newConfig.definitionId,
                        filter: f,
                        bySelection: false
                    };
                })
            );
        }

        // reset selection state.
        this.selectedPoints = null;

        this.closeModal();
    }

    closeModal(): void {
        this.setState({
            showModal: false,
        });
    }

    openModal(): void {
        this.setState({
            showModal: true,
        });
    }

    queryFromConfig(chartConfig: IDwChartConfig) : null | DwQuery {
        const wrapper = this.state.definitionWrappers.find((d:any) => d.id === chartConfig.definitionId);
        const chartProvider = this.chartTypes.find((p: ChartProvider) => p.name === chartConfig.chartType);

        // convert the config to a query object.
        const query = chartProvider!.getQuery(wrapper.definition, chartConfig.chartConfig);

        return query;
    }

    publishFilters(filters: IDwFilterWarapper[]) {
        //
        // this will publish the current state of the filters. this state will
        // completely replace the state already defined by this widget.
        //
        console.log('chart > publishing filters', this.props.widgetInstance.id, filters);

        this.socket.emit('chart', {
            command: 'filterChange',
            filters: filters,
            widgetInstanceId: this.props.widgetInstance.id,
            widgetInstanceTitle: this.props.widgetInstance.title
        });
    }

    onPlotDeselect() {
        console.log('chart > onPlotDeselect');

        this.selectedPoints = null;

        this.setState({
            selectionFilter: null
        });

        // broadcast to others that the user de-selected items on the chart.
        //
        this.socket.emit('chart', {
            command: 'filterSelected',
            filter: null,
            widgetInstanceId: this.props.widgetInstance.id,
            widgetInstanceTitle: this.props.widgetInstance.title
        });

        // only include the configured.
        //
        const query = this.queryFromConfig(this.chartConfig!);

        if(query){
            this.publishFilters(
                query.filters?.map((f: IDwFilter) => {
                    return {
                        definitionId: this.chartConfig!.definitionId,
                        filter: f,
                        bySelection: false
                    };
                })
            );
        }
    }

    onPlotSelect(selection: any) {
        console.log('chart > onPlotSelect', selection);

        //
        // TODO this does give you lassoPoints, which could be converted
        // to a polygon and each point could be tested for whether it
        // is contained (more efficient than sending entire set of selected entity ids)
        //
        if (!selection) {
            console.log('non-rectangular select not yet supported', selection);
            return;
        }

        if(this.state.selectedChartProvider != null) {
            const wrapper = this.state.definitionWrappers.find((d: any) => d.id === this.chartConfig!.definitionId);

            // get an IDwFilter for the selected data points.
            //
            let selectionFilters = this.state.selectedChartProvider.filterFromSelection(wrapper.definition, this.chartConfig!.chartConfig, selection);

            if(!selectionFilters) {
                return;
            }

            // broadcast to others that the user selected items on the chart.
            // this is only used by the same widget id to keep dashboards
            // on the same session in-sync.
            //
            this.socket.emit('chart', {
                command: 'filterSelected',
                filter: selectionFilters,
                widgetInstanceId: this.props.widgetInstance.id,
                widgetInstanceTitle: this.props.widgetInstance.title
            });

            // convert the current config to a query so we can get the filters.
            //
            const query = this.queryFromConfig(this.chartConfig!);

            if(query) {
                // include the existing filters from the config and the selection filter.
                //
                const filterWrappers: IDwFilterWarapper[] = query.filters?.map((f: IDwFilter) => {
                    return {
                        definitionId: this.chartConfig!.definitionId,
                        filter: f,
                        bySelection: false
                    };
                });

                this.setState({
                    selectionFilter: selectionFilters
                });

                let filters = [...filterWrappers];

                selectionFilters?.map((f:any) => {
                    filters.push({
                        definitionId: this.chartConfig!.definitionId,
                        filter: f,
                        bySelection: true
                    });
                });

                this.publishFilters(filters);
            }
        }
    }

    onPlotSelectItem(selection: any) {
        console.log('chart > onPlotSelectItem', selection);

        if (!selection || !selection.event) {
            return;
        }

        if(!this.state.selectedChartProvider) {
            return;
        }
    }

    onPlotRedraw() {
        if(this.state.chart.data.length > 0) {
            console.log('xx plot redraw');
        }
    }

    setShowHoverButtons(tf:boolean){
        this.setState({
          showHoverButtons: tf
        });
    }

    renderPlot() {
        return <Plot
            config={{
                modeBarButtonsToRemove: [
                    // names defined here https://github.com/plotly/plotly.js/blob/master/src/components/modebar/buttons.js
                    'lasso2d',
                    'autoScale2d',
                    'hoverCompareCartesian',
                    'toggleSpikelines',
                ]
            }}
            onSelected={(params: any) => this.onPlotSelect(params)}
            onDeselect={() => this.onPlotDeselect()}
            onAfterPlot={() => this.onPlotRedraw()}
            onClick={(params: any) => this.onPlotSelect(params)}
            useResizeHandler={true}
            style={{ width: '100%', height: '100%' }}
            data={this.state.chart.data}
            layout={this.state.chart.layout}
            revision={this.state.revisionNo}
        />
    }

    render() {
        return (
            <div className="chart2-container" style={{ width: '100%', height: '100%' }}
                onMouseEnter={() => this.setShowHoverButtons(true)}
                onMouseLeave={() => this.setShowHoverButtons(false)}
            >
                <div className="mouse-event-div"></div>
                <div className={this.state.showHoverButtons ? "map-widget-hover-buttons" : "map-widget-hover-buttons d-none"} >
                    <Button variant="secondary" size="sm" style={{ position: 'absolute', top: 0, left: 0, zIndex:2, height: '30px', width: '33px' }}
                        onClick={() => this.openModal()}>
                            <FontAwesomeIcon icon={faCog}/>
                    </Button>
                </div>
                {
                        this.state.selectionFilter &&
                        <Button variant="secondary" size="sm" title="remove filter" style={{ position: 'absolute', top: 0, right: 30, zIndex: 2, height: '30px', width: '33px' }}
                        onClick={() => this.onPlotDeselect()}>
                            <FontAwesomeIcon icon={faFilter} />
                        </Button>
                }
                { this.renderPlot() }

                {
                    this.state.showModal ?
                    <Modal
                        show={this.state.showModal}
                        onHide={() => this.closeModal()}
                        backdrop="static"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Configure Chart</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        {this.chartPropertiesForm()}
                        </Modal.Body>
                    </Modal>
                    : ''
                }
            </div>
        );
    }
}

export default withApollo<any, any>(DashboardChart2Widget);
